module.exports = __webpack_public_path__ + "img/SBOBET.43505d13.svg";